import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Request } from '../models/request.model';

@Injectable()
export class ComponentMessengerService {
    private requestMessageSource: BehaviorSubject<Request> = new BehaviorSubject(new Request());
    private searchQueryMessageSource: BehaviorSubject<string> = new BehaviorSubject('');
    private requestsMessageSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private requestViewMessageSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private requestPasswordMessageSource: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public requestMessage = this.requestMessageSource.asObservable();
    public searchQueryMessage = this.searchQueryMessageSource.asObservable();
    public requestsMessage = this.requestsMessageSource.asObservable();
    public requestViewMessage = this.requestViewMessageSource.asObservable();
    public requestPasswordMessage = this.requestPasswordMessageSource.asObservable();

    public requestCreated(isNewRequestCreated: boolean) {
        this.requestsMessageSource.next(isNewRequestCreated);
    }

    public requestOpened(isRequestOpened: boolean) {
        this.requestViewMessageSource.next(isRequestOpened);
    }

    public requestUpdated(request: Request) {
        this.requestMessageSource.next(request);
    }

    public passwordRequested(isPasswordRequested: boolean) {
        this.requestPasswordMessageSource.next(isPasswordRequested);
    }

    public searchQueryUpdated(query: string) {
        this.searchQueryMessageSource.next(query);
    }
}
